<template>
  <div>
    <div class="card top-draft" style="margin-bottom: 0px">
      <!-- <div class="col-lg-12 mg-top-1">
        <b-button variant="primary" @click="toCreate()">
          <i class="bx bx-plus font-size-16 align-middle me-2"></i>
          添加
        </b-button>
      </div> -->

      <div class="col-lg-12 list-header pad-header-bg clearfix">
        <div class="app-list-sort header-item-fix">
          <b-dropdown>
            <template v-slot:button-content>
              <sort-icon />
            </template>
            <b-dropdown-item
              v-for="(item, index) in sortList"
              :key="index"
              @click="listSort(item)"
            >
              <span class="pull-left" v-if="pageParams.sortBy == item.value">
                <i
                  v-if="pageParams.order == 'desc'"
                  class="bx bx-down-arrow-alt font-size-18 pull-left"
                ></i>
                <i
                  v-if="pageParams.order == 'asc'"
                  class="bx bx-up-arrow-alt font-size-18"
                ></i>
              </span>
              <span :class="{ padleft: pageParams.sortBy != item.value }">{{
                item.text
              }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="header-item-fix">
          <b-form-input
            size="sm"
            type="text"
            v-model="pageParams.contentKeyword"
            @keyup.enter.native="getList"
            placeholder="搜索标题"
          ></b-form-input>
          <b-button size="sm" variant="primary" @click="getList()">
            <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
            搜索
          </b-button>
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="resetParams()"
          >
            <i class="bx bx-revision font-size-16 align-middle"></i>
            重置
          </b-button>
        </div>
        <div class="header-item-fix">
          <b-form-select
            @change="getList()"
            v-model="pageParams.state"
            class="form-select"
            :options="statusList"
            type="text"
          ></b-form-select>
        </div>
      </div>

      <div class="col-lg-12">
        <el-table
          v-loading="tableLoading"
          :data="items"
          style="width: 100%"
          :stripe="true"
          @selection-change="tableSelectionChange"
        >
          <el-table-column fixed="left" type="selection" align="center">
          </el-table-column>
          <el-table-column label="ID" prop="id" width="60" fixed="left">
          </el-table-column>
          <el-table-column label="标题" min-width="200" fixed="left">
            <template slot-scope="item">
              <div style="cursor: pointer" @click="showPre(item.row)">
                <show-repeat-title
                  v-if="repeatTitle"
                  :repeatTitle="repeatTitle"
                  :title="item.row.title"
                ></show-repeat-title>
                <span v-else>{{ item.row.title }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="封面" width="120">
            <template slot-scope="item">
              <img
                v-if="item.row.image"
                class="w-3-rem"
                :src="`${item.row.image}`"
                alt
              />
              <img
                v-if="!item.row.image"
                class="w-3-rem"
                src="@/assets/images/image-null.jpg"
                alt=""
              />
            </template>
          </el-table-column>
          <!-- <el-table-column label="标签" width="100">
            <template slot-scope="item">
              {{ item.row.tagName || "--" }}
            </template>
          </el-table-column> -->
          <el-table-column label="审核状态" width="80">
            <template slot-scope="item">
              <span v-if="item.row.verifyState == 0">草稿</span>
              <span v-if="item.row.verifyState == 1">通过</span>
              <span v-if="item.row.verifyState == 2">驳回</span>
              <span v-if="item.row.verifyState == 3">待审核</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="状态" width="80">
            <template slot-scope="item">
              <el-tooltip
                v-if="power['显示/隐藏']"
                :content="item.row.showState == 1 ? '点击隐藏' : '点击显示'"
              >
                <span
                  @click="batchHide(item.row)"
                  v-if="item.row.showState == 1"
                  class="dsply-fix status-open"
                  ><i></i>显示</span
                >
                <span
                  @click="batchShow(item.row)"
                  v-if="item.row.showState == 0"
                  class="dsply-fix status-off"
                  ><i></i>隐藏</span
                >
              </el-tooltip>
              <div v-if="!power['显示/隐藏']">
                <span
                  v-if="item.row.showState == 1"
                  class="dsply-fix status-open"
                  ><i></i>显示</span
                >
                <span
                  v-if="item.row.showState == 0"
                  class="dsply-fix status-off"
                  ><i></i>隐藏</span
                >
              </div>
            </template>
          </el-table-column> -->
          <el-table-column label="发稿人/创建时间" width="158">
            <template slot-scope="item">
              <div style="display: flex; flex-direction: column">
                <span>{{ item.row.creator || "--" }}</span>
                <span>{{ item.row.createdAt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="审核人/审核时间" width="158">
            <template slot-scope="item">
              <div style="display: flex; flex-direction: column">
                <span>{{ item.row.verifyName || "--" }}</span>
                <span>{{ item.row.verifiedAt }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
              label="预览链接"
              width="200">
            <template slot-scope="item">
              <a
                  target="_blank "
                  v-if="item.row.previewUrl"
                  :href="item.row.previewUrl"
              >{{ item.row.previewUrl }}</a
              ><span v-else>--</span>
            </template>
          </el-table-column> -->
          <el-table-column label="发布日期" width="158" prop="publishedAt">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="165">
            <template slot-scope="item">
              <div
                class="optWrap"
                style="display: flex; flex-wrap: wrap"
                v-if="item.row.verifyState == 1"
              >
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row)"
                    v-if="power['编辑详情']"
                  >
                    编辑详情
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['评论']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toComments(item.row)"
                  >
                    评论
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <el-popover
                    @show="showQRcode(item.row)"
                    placement="bottom"
                    title="分享二维码"
                    width="200"
                    trigger="hover"
                  >
                    <div>
                      <img :src="currentQRcode" />
                    </div>
                    <button
                      slot="reference"
                      v-if="power['查看']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="copyUrl(item.row)"
                    >
                      复制预览链接
                    </button>
                  </el-popover>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-danger"
                    @click="remove(item.row)"
                    v-if="power['移除']"
                  >
                    移除
                  </button>
                </div>
              </div>

              <div
                class="optWrap"
                style="display: flex; flex-wrap: wrap"
                v-if="item.row.verifyState == 0"
              >
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row)"
                    v-if="power['编辑详情']"
                  >
                    编辑详情
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="batchExamine(item.row)"
                    v-if="power['提交审核/撤销审核/驳回原因']"
                  >
                    {{ verifyFlag == 1 ? "免审发布" : "提交审核" }}
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['评论']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toComments(item.row)"
                  >
                    评论
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <el-popover
                    @show="showQRcode(item.row)"
                    placement="bottom"
                    title="分享二维码"
                    width="200"
                    trigger="hover"
                  >
                    <div>
                      <img :src="currentQRcode" />
                    </div>
                    <button
                      slot="reference"
                      v-if="power['查看']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="copyUrl(item.row)"
                    >
                      复制预览链接
                    </button>
                  </el-popover>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-danger"
                    @click="remove(item.row)"
                    v-if="power['移除']"
                  >
                    移除
                  </button>
                </div>
              </div>

              <div
                class="optWrap"
                style="display: flex; flex-wrap: wrap"
                v-if="item.row.verifyState == 3"
              >
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row, 'allModify')"
                  >
                    查看
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="batchRevert(item.row)"
                    v-if="power['提交审核/撤销审核/驳回原因']"
                  >
                    撤销审核
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['评论']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toComments(item.row)"
                  >
                    评论
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <el-popover
                    @show="showQRcode(item.row)"
                    placement="bottom"
                    title="分享二维码"
                    width="200"
                    trigger="hover"
                  >
                    <div>
                      <img :src="currentQRcode" />
                    </div>
                    <button
                      slot="reference"
                      v-if="power['查看']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="copyUrl(item.row)"
                    >
                      复制预览链接
                    </button>
                  </el-popover>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-danger"
                    @click="remove(item.row)"
                    v-if="power['移除']"
                  >
                    移除
                  </button>
                </div>
              </div>

              <div
                class="optWrap"
                style="display: flex; flex-wrap: wrap"
                v-if="item.row.verifyState == 2"
              >
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row)"
                    v-if="power['编辑详情']"
                  >
                    编辑详情
                  </button>
                </div>

                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="openReject(item.row)"
                    v-if="power['提交审核/撤销审核/驳回原因']"
                  >
                    驳回原因
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['评论']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toComments(item.row)"
                  >
                    评论
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <el-popover
                    @show="showQRcode(item.row)"
                    placement="bottom"
                    title="分享二维码"
                    width="200"
                    trigger="hover"
                  >
                    <div>
                      <img :src="currentQRcode" />
                    </div>
                    <button
                      slot="reference"
                      v-if="power['查看']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="copyUrl(item.row)"
                    >
                      复制预览链接
                    </button>
                  </el-popover>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-danger"
                    @click="remove(item.row)"
                    v-if="power['移除']"
                  >
                    移除
                  </button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- :isBatch 如果有批量操作就传这个参数 没有就不传
        batchs 批量操作的列表 
        pageCallback 分页组件的回调方法 -->
        <pagination
          class="bath_r_20"
          :isBatch="true"
          :total="pageTotal"
          :batchs="batchs"
          :pageSize="pageParams.pageSize"
          :page.sync="pageParams.page"
          ref="page"
          @pageCallback="pageCallback"
        ></pagination>
      </div>
    </div>
    <examine-dialog ref="examine" @pageCallback="pageCallback"></examine-dialog>
    <el-drawer
      :visible.sync="drawer"
      :show-close="false"
      size="450px"
      @open="open()"
      @closed="closed()"
    >
      <iframe
        v-if="showIframe"
        ref="iframe"
        class="iframe-item"
        :src="rowData.previewUrl"
      ></iframe>
    </el-drawer>
    <!-- 驳回的弹窗 -->
    <examine-reject-dialog ref="examineRejectDialog"></examine-reject-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import content from "../../../server/api/videoPublish";
import examineDialog from "./examineDialog";
import { getPreLink, copyLink, getCopyLink, changeList } from "@/util/fun.js";
import examineRejectDialog from "@/components/examineRejectDialog.vue";
import ShowRepeatTitle from "@/components/ShowRepeatTitle.vue";

/**
 * Contacts-list component
 */
export default {
  components: {
    examineDialog,
    examineRejectDialog,
    ShowRepeatTitle,
  },

  data() {
    return {
      showIframe: false,
      rowData: {},
      drawer: false,
      choiceListIds: [], //当前所选择的id
      pageParams: {
        page: 1,
        pageSize: 30,
        type: "0", //0:草稿，2：文章列表
        state: "",
        contentKeyword: "",
        mediaId: "",
      },
      items: [],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        // { text: "显示", value: "1" },
        // { text: "隐藏", value: "2" },
        // { text: "删除", value: "2" },
        // { text: "撤稿", value: "3" },
        // { text: "提交审核", value: "4" },
      ],
      statusList: [
        { text: "审核状态", value: "" },
        { text: "草稿", value: "0" },
        { text: "待审核", value: "3" },
        { text: "驳回", value: "2" },
      ],
      sortList: [
        { text: "阅读", value: "viewNum" },
        { text: "评论", value: "commentNum" },
        { text: "日期", value: "createTime" },
      ],
      power: "",
      verifyFlag: "",
      tableLoading: false,
      currentQRcode: "",
      repeatTitle: "",
      pageTotal: 0,
    };
  },

  created() {
    let data = JSON.parse(localStorage.chosedMedia);
    this.verifyFlag = data.verifyFlag;
    this.pageParams.mediaId = data.id;
    this.power = this.utils.currentPower("创作平台-视频发布");
    if (this.power["移除"]) {
      this.batchs.push({ text: "删除", value: "2" });
    }
    if (this.power["提交审核/撤销审核/驳回原因"]) {
      this.batchs.push({
        text: data.verifyFlag == 1 ? "免审发布" : "提交审核",
        value: "4",
      });
    }
    if (this.power["提交审核/撤销审核/驳回原因"] && !this.verifyFlag) {
      this.batchs.push({ text: "撤销审核", value: "3" });
    }

    if (this.verifyFlag) {
      this.batchs.splice(3, 1);
    }
    //从详情、评论返回列表时不重新调用列表接口
    let obj = this.getCache("video-draft");
    if (obj.pageParams) {
      this.pageParams = obj.pageParams;
      if (obj.pageParams.contentKeyword) {
        this.repeatTitle = obj.pageParams.contentKeyword;
      }
    }
    if (obj && obj.list && obj.list[0]) {
      console.log("使用缓存");
      this.items = obj.list;
      this.pageTotal = obj.pageTotal;
      //从详情返回时更新列表数据
      obj = this.getCache("video-edit");
      console.log("获取的编辑缓存", obj);
      this.addCache("video-edit", "");
      if (obj && obj.id) {
        //检测编辑的文章id是否在本列表
        let judge = this.items.some((item) => {
          if (item.id == obj.id) {
            return true;
          }
        });
        //获取编辑的文章详情
        content.detail({ id: obj.id }).then((res) => {
          console.log("视频详情", res);
          let detail = res.data;
          if (detail.verifyState != 1) {
            if (judge) {
              //如果审核状态未通过且在本列表则更新对应数据
              this.items = this.items.map((item) => {
                if (item.id == obj.id) {
                  return { ...item, ...detail };
                } else {
                  return item;
                }
              });
              this.updateCache("video-draft", {
                list: this.items,
              });
            } else {
              this.getList(false); //不显示加载图标更新列表
            }
          } else {
            //如果审核状态通过但之前在本列表则删除对应数据
            if (judge) {
              this.pageTotal -= 1;
              this.items = changeList("delete", this.items, [detail.id], "id");
            }
          }
        });
      }
    } else {
      this.getList();
      this.addCache("video-edit", "");
    }
  },
  beforeDestroy() {
    this.addCache("video-draft", {
      list: this.items,
      pageTotal: this.pageTotal,
      pageParams: this.pageParams,
    });
  },

  methods: {
    showPre(item) {
      this.rowData.previewUrl = getPreLink(item);
      this.drawer = true;
    },
    async showQRcode(item) {
      let url = getCopyLink(item);
      if (url) {
        this.currentQRcode = await this.$qrCode.toDataURL(url);
      }
    },
    copyUrl(item) {
      copyLink(getCopyLink(item), "链接");
    },
    closed() {
      this.showIframe = false;
    },
    open() {
      this.showIframe = true;
    },
    tableSelectionChange(selectValues) {
      this.choiceListIds = [];
      selectValues.map((val) => {
        this.choiceListIds.push(val.id);
      });
    },
    //获取列表数据
    getList(showLoading) {
      this.repeatTitle = this.pageParams.contentKeyword;
      let params = this.another(this.pageParams);
      this.cleanObj(params);
      console.log("草稿搜索参数", params);
      if (showLoading !== false) {
        this.tableLoading = true;
        this.items = [];
      }
      this.choiceListIds = [];
      content.videos(params).then((resp) => {
        if (resp.data) {
          this.tableLoading = false;
          if (resp.data.items) {
            // resp.data.items[0].isLy = 1
            // resp.data.items[4].isLy = 1
            // resp.data.items[6].verifyState = 3
            // resp.data.items[4].verifyState = 2
            this.items = resp.data.items;
            this.updateCache("video-draft", {
              list: this.items,
            });
            console.log("草稿列表", this.items);
            this.pageTotal = resp.data.total || 0;
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "examine") {
        //提交审核后刷新
        this.getList();
      }
      if (obj.code === "batch") {
        if (this.choiceListIds.length < 1) {
          this.info("未选择内容");
          return;
        }
        //处理批量操作
        console.log(this.choiceListIds, "批量的id");
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击显示的处理方法
            this.batchShow();
          } else {
            Vue.swal("请选择要显示的内容");
            return;
          }
        }
        if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            //点击删除的处理方法
            this.remove();
          } else {
            Vue.swal("请选择要删除的内容");
            return;
          }
        }
        if (obj.batch == 3) {
          if (this.choiceListIds.length) {
            //点击撤稿的处理方法
            this.batchRevert();
          } else {
            Vue.swal("请选择要撤稿的内容");
            return;
          }
        }
        if (obj.batch == 4) {
          if (this.choiceListIds.length) {
            //点击提交审核的处理方法
            // 要么全部为商家视频，要么全部为媒体号视频，所以可以取第0个
            if (this.items[0].isLy == 1) {
              let choiceItems = [];
              for (var i = 0; i < this.choiceListIds.length; i++) {
                let choiceId = this.choiceListIds[i];
                for (var j = 0; j < this.items.length; j++) {
                  if (this.items[j].id == choiceId) {
                    choiceItems.push(this.items[j]);
                  }
                }
              }
              this.$refs.examine.showModel(choiceItems, "arr");
            } else {
              this.batchExamine();
            }
          } else {
            Vue.swal("未选择内容");
            return;
          }
        }
      }
    },

    //添加
    toCreate() {
      this.$router.push({
        name: "videoPublishDetail",
      });
    },

    //去编辑
    toDetail(item, allModify) {
      if (allModify) {
        this.$router.push({
          name: "videoPublishDetail",
          query: { id: item.id, allModify: true },
        });
      } else {
        this.$router.push({
          name: "videoPublishDetail",
          query: { id: item.id },
        });
      }
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.sortBy = "";
      this.pageParams.order = "";
      this.pageParams.state = "";
      this.pageParams.contentKeyword = "";
      this.repeatTitle = "";
      this.getList();
    },

    openReject(item) {
      this.$refs.examineRejectDialog.showModel(item);
      // Swal.fire({
      //   title: "驳回原因",
      //   text: item.rejectReason,
      //   confirmButtonColor: "#556ee6",
      // });
    },

    // 排序
    listSort(item) {
      if (this.pageParams.sortBy == item.value) {
        this.pageParams.sortBy = item.value;
        if (this.pageParams.order == "asc") {
          this.pageParams.order = "desc";
        } else {
          this.pageParams.order = "asc";
        }
      } else {
        this.pageParams.sortBy = item.value;
        this.pageParams.order = "desc"; //默认倒序
      }
      this.getList();
    },

    batchHide(item) {
      Swal.fire({
        title: "确定隐藏?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "隐藏",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.ids = this.choiceListIds;
          content.hide(params).then((resp) => {
            if (resp.code === 0) {
              this.success("隐藏成功");
              // this.getList(); 修改状态成功不刷新列表，直接更改数据
              this.items = changeList(
                "changeAttribute",
                this.items,
                params.ids,
                {
                  showState: 0,
                }
              );
              if (!item) {
                this.choiceListIds = [];
              }
            } else {
              Vue.swal(resp.msg || "修改失败");
            }
          });
        }
      });
    },

    batchShow() {
      Swal.fire({
        title: "确定显示?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "显示",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.ids = this.choiceListIds;
          content.show(params).then((resp) => {
            if (resp.code === 0) {
              this.success("显示成功");
              // this.getList(); 修改状态后不调用列表接口，直接改数据
              this.items = changeList(
                "changeAttribute",
                this.items,
                params.ids,
                {
                  showState: 1,
                }
              );
              if (!item) {
                this.choiceListIds = [];
              }
            } else {
              Vue.swal(resp.msg || "修改失败");
            }
          });
        }
      });
    },

    batchRevert(item) {
      Swal.fire({
        title: "确定撤销审核?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          content.revert(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "操作成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              // this.getList(); 撤销成功直接更改列表数据
              if (!item) {
                this.choiceListIds = [];
              }
              this.items = changeList(
                "changeAttribute",
                this.items,
                params.ids,
                {
                  verifyState: 0,
                }
              );
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    batchExamine(item) {
      // item.isLy = 0 到管理后台（天问）审核
      // item.isLy = 1 //到龙渊审核
      // let user = JSON.parse(this.cookies.getCookie("user"));
      // 媒体号进入龙渊，商家进入天问审核 userType 0普通用户(app) 1媒体号(pgc) 2商家 3水军(运营用户)
      // if (user.userType == 1) {
      //   this.$refs.examine.showModel(item);
      // }
      // if (user.userType == 2) {
      Swal.fire({
        title: this.verifyFlag != 1 ? "确认提交审核?" : "确认免审发布?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          content.examine(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: this.verifyFlag != 1 ? "提交成功！" : "发布成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              if (!item) {
                this.choiceListIds = [];
              }
              if (this.verifyFlag == 1) {
                // this.getList(); 发布成功时不调用列表接口,直接从列表删除对应内容
                if (this.items.length == params.ids.length) {
                  this.getList();
                } else {
                  this.pageTotal -= params.ids.length;
                  this.items = changeList(
                    "delete",
                    this.items,
                    params.ids,
                    "id"
                  );
                }
              } else {
                // this.getList(); 提审成功直接更改列表数据
                this.items = changeList(
                  "changeAttribute",
                  this.items,
                  params.ids,
                  {
                    verifyState: 3,
                  }
                );
              }
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
      // }
    },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          content.remove(params).then((resp) => {
            if (resp.code === 0) {
              this.success("删除成功");
              // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
              if (this.items.length == params.ids.length) {
                this.getList();
              } else {
                this.pageTotal -= params.ids.length;
                this.items = changeList("delete", this.items, params.ids, "id");
                if (!item) {
                  this.choiceListIds = [];
                }
              }
            } else {
              this.warning(resp.msg || "删除失败");
            }
          });
        }
      });
    },
    toComments(item) {
      this.$router.push({
        name: "videoComments",
        query: { id: item.id },
      });
    },
  },
};
</script>

<style scoped>
.iframe-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
::v-deep .el-table thead .el-table__cell:first-child .cell {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:first-child .cell {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
::v-deep .el-table thead .el-table__cell:first-child .cell .el-checkbox {
  margin-bottom: 0 !important;
}
::v-deep
  .el-table
  tbody
  > .el-table__row
  .el-table__cell:first-child
  .cell
  .el-checkbox {
  margin-bottom: 0 !important;
}
::v-deep .el-table thead .el-table__cell:nth-child(2) .cell {
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:nth-child(2) .cell {
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:last-child .cell {
  padding-right: 0px !important;
}
</style>
